import { Button, Stack } from "@mui/material";
import { Calendar } from "mt-components";
import { colors, setAlpha } from "../../../../helpers/colors";
import useAvailability from "../../../../hooks/useAvailability";

type AvailabilityProps = {
  productId: string;
  reservationDate: string;
  setReservationDate: (reservationDate: string) => void;
  reservationTime: string;
  setReservationTime: (reservationTime: string) => void;
  setAvailableSpots: (availableSpots: number) => void;
  numSelectedPeople: number;
  isPrivate: boolean;
};

export default function Availability(props: AvailabilityProps) {
  const {
    checkTimeslotIsAvailable,
    getTimeslots,
    checkDateIsAvailable,
    getMaxSeatsLeft,
    error,
    loading,
    availability,
    month,
    setMonth,
  } = useAvailability();

  if (error) return <>Error loading availability</>;

  return (
    <div>
      <Calendar
        loading={loading}
        noPast
        month={month}
        setMonth={setMonth}
        data={Object.keys(availability).map((date) => ({
          day: date,
          backgroundColor: !checkDateIsAvailable(
            date,
            props.numSelectedPeople,
            props.isPrivate
          )
            ? colors.brightGray
            : props.reservationDate === date
            ? setAlpha(colors.blue, 0.2)
            : undefined,
          onClick: checkDateIsAvailable(
            date,
            props.numSelectedPeople,
            props.isPrivate
          )
            ? (date) => {
                props.setReservationDate(date);
                props.setReservationTime("");
              }
            : undefined,
        }))}
      />
      <Timeslots />
    </div>
  );

  function Timeslots() {
    if (!props.reservationDate) return <></>;

    return (
      <Stack style={{ marginTop: "10px" }} direction="row" spacing={1}>
        {Object.keys(getTimeslots(props.reservationDate)).map((time) => {
          const seatsLeft = getMaxSeatsLeft(props.reservationDate, time);
          const isAvailable = checkTimeslotIsAvailable(
            props.reservationDate,
            time,
            props.numSelectedPeople,
            props.isPrivate
          );

          return (
            <Button
              color="inherit"
              style={{
                height: "56px",
                width: "88px",
                padding: "0px",
                backgroundColor: !isAvailable
                  ? colors.brightGray
                  : time === props.reservationTime
                  ? setAlpha(colors.blue, 0.2)
                  : colors.white,
                fontSize: "16px",
                lineHeight: "18px",
                fontWeight: "700",
              }}
              variant="contained"
              size="small"
              disabled={!isAvailable}
              onClick={() => {
                props.setReservationTime(time);
                props.setAvailableSpots(seatsLeft);
              }}
            >
              <p>
                {time}
                {seatsLeft <= 3 && seatsLeft > 0 && (
                  <>
                    <br />
                    <span
                      style={{
                        fontSize: "10px",
                        color:
                          seatsLeft < props.numSelectedPeople
                            ? colors.lightGray
                            : colors.cinnabar,
                      }}
                    >
                      {seatsLeft} {seatsLeft > 1 ? <>spots</> : <>spot</>} left
                    </span>
                  </>
                )}
                {seatsLeft <= 0 && (
                  <>
                    <br />
                    <span style={{ fontSize: "10px" }}>full</span>
                  </>
                )}
              </p>
            </Button>
          );
        })}
      </Stack>
    );
  }
}
